import classNames from "classnames";
import UrlTableMenuFilterList from "components-for/tables/url-table-menu-filter-list";
import {
    Cell,
    Column,
    EnumLabel,
    formatEnumOptions,
    Heading,
    TableMenuSection,
    useQueryParameters,
} from "@edgetier/client-components";
import { createClassName } from "./interactions-table-state-column.utilities";
import { FunctionComponent, memo } from "react";
import { IInteraction, InteractionState } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-state-column.types";
import { INTERACTIONS_TABLE_PREFIX } from "constants/interactions";
import "./interactions-table-state-column.scss";

/**
 * Show the current state of an interaction as a table column.
 * @returns Interaction state column.
 */
const InteractionsTableStateColumn: FunctionComponent<IProps> = () => {
    const { interactionState } = useQueryParameters(
        { interactionState: String },
        { prefix: INTERACTIONS_TABLE_PREFIX }
    );

    return (
        <Column>
            <Heading
                isFiltered={typeof interactionState === "string"}
                menu={
                    <TableMenuSection>
                        <UrlTableMenuFilterList
                            labelProperty="label"
                            items={formatEnumOptions(InteractionState, [InteractionState.Complete])}
                            queryParameter="interactionState"
                            queryParameterPrefix={INTERACTIONS_TABLE_PREFIX}
                            valueProperty="value"
                        />
                    </TableMenuSection>
                }
            >
                State
            </Heading>
            <Cell<IInteraction>>
                {({ interactionState }) => (
                    <span className={classNames("interactions-table-state-column", createClassName(interactionState))}>
                        <EnumLabel>{interactionState}</EnumLabel>
                    </span>
                )}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableStateColumn);
